import React from 'react'
import { yupResolver } from '@hookform/resolvers/yup'

import { useControlledForm, useFormApiError } from 'hooks'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

const useCopyTemplateForm = onConfirm => {
  const [apiError, setApiError] = React.useState(null)

  const defaultValues = getDefaultValues()
  const schema = getSchema()

  const handleFormData = React.useCallback(
    async data => {
      await onConfirm(
        { title: data?.name, department: data?.department?.value },
        { onError: setApiError },
      )
    },
    [onConfirm],
  )

  const {
    control,
    formState,
    handleFormApiError,
    handleFormReset,
    handleFormSubmit,
    watch,
  } = useControlledForm({
    defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  useFormApiError({ apiError }, handleFormApiError)

  return {
    state: { control, formState },
    handlers: { handleFormReset, handleFormSubmit, watch },
  }
}

export const useCopyTemplateModal = handlers => {
  const { onCancel, onClose, onConfirm } = handlers

  const {
    state: { control, formState },
    handlers: { handleFormReset, handleFormSubmit, watch },
  } = useCopyTemplateForm(onConfirm)

  const handleCancel = React.useCallback(() => {
    onCancel()
    handleFormReset()
  }, [handleFormReset, onCancel])

  const handleClose = React.useCallback(() => {
    onClose()
    handleFormReset()
  }, [handleFormReset, onClose])

  return {
    state: { copy: { control, formState, watch } },
    handlers: {
      handleCancel,
      handleClose,
      handleConfirm: handleFormSubmit,
    },
  }
}
